export default __webpack_public_path__ + "static/ryan-d6f0205aca95c583038bb7090babb780.jpeg";